export class SystemUser {
    id: string;
    firstName: string;
    familyName: string;
    username: string;
    usingLevel: number;
    password: string;
    langId: string;
}